import PolicyNotice from './PolicyNotice';

export default PolicyNotice;
